export const ACADEMY = {
  name: "Rythmbara Dance Academy",
  master: "Triveni Chowdary",
  phone: "+91 9951388218",
  phoneRaw: "+919951388218",
  email: "kakarlatriveni@gmail.com",
  whatsapp: "919951388218",
  instagram: "triveni.chowdary",
  instagramUrl: "https://instagram.com/triveni.chowdary",
  youtube: "kakarla.triveni",
  youtubeUrl: "https://youtube.com/@kakarla.triveni",
  hours: {
    morning: "7:00 AM – 10:00 AM",
    evening: "6:00 PM – 9:00 PM",
  },
  address: "DnY's Prestige Heights, Road No. 42H, Mayuri Nagar, Nizampet, Miyapur, Hyderabad, Telangana 500049",
  mapLink: "https://maps.app.goo.gl/1bz3YgUzWycA9tz99",
  mapEmbed:
    "https://www.google.com/maps?q=DnY's%20Prestige%20Heights,%20Road%20No.%2042H,%20Mayuri%20Nagar,%20Nizampet,%20Miyapur,%20Hyderabad,%20Telangana%20500049&output=embed",
};

export const WHATSAPP_LINK = `https://wa.me/${ACADEMY.whatsapp}?text=${encodeURIComponent(
  "Hi Rythmbara Dance Academy! I'd like to know more about your classes."
)}`;

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Courses", to: "/courses" },
  { label: "Gallery", to: "/gallery" },
  { label: "Events", to: "/events" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Contact", to: "/contact" },
];

export const DANCE_STYLES = [
  "Bharatanatyam", "Kuchipudi", "Classical Dance", "Western Dance", "Hip Hop",
  "Freestyle", "Bollywood", "Folk Dance", "Semi Classical", "Kids Dance",
];
